import { render, staticRenderFns } from "./FeedbackFormBlock.vue?vue&type=template&id=5d7b267e&scoped=true&"
import script from "./FeedbackFormBlock.vue?vue&type=script&lang=js&"
export * from "./FeedbackFormBlock.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFormBlock.vue?vue&type=style&index=0&id=5d7b267e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b267e",
  null
  
)

export default component.exports